import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TeamInjuriesComponent } from './team-injuries.component';
import { TeamAllInjuriesComponent } from './team-injuries-list/team-all-injuries.component';
import { TeamPlayerInjuriesComponent } from './team-player-injuries/team-player-injuries.component';
import { TeamInjuryDetailsComponent } from './team-injury-details/team-injury-details.component';


const routes: Routes = [
  {
    path: '',
    component: TeamInjuriesComponent,
    children: [
      { path: 'team-all-injuries', component: TeamAllInjuriesComponent },
      { path: 'team-player-injuries/:teamID/:playerID', component: TeamPlayerInjuriesComponent },
      { path: 'team-player-injuries/:teamID/:playerID/:injuryID', component: TeamInjuryDetailsComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TeamInjuriesRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/team-injuries/team-injuries-routing.module.ts